import React from 'react'
import styled from '@emotion/styled'
import { colors, radius, spacing } from '@mobi/component-library/Foundations'
import { Flex } from '@mobi/component-library/Misc/Flex'
import { LoadingPlaceholder } from '@mobi/component-library/Misc/LoadingPlaceholder'

export const HeaderSkeleton: React.FC<{ isHeaderOnly?: boolean }> = ({ isHeaderOnly }) => (
  <CardWrapperStyled
    style={
      isHeaderOnly
        ? {
            padding: spacing.sm,
            borderRadius: 0,
            borderBottom: `1px solid ${colors.neutral[200]}`,
          }
        : undefined
    }
  >
    <Flex flexDirection='row' justifyContent='space-between'>
      <Flex flexDirection='row' gap={spacing.smx1}>
        <Flex flexDirection='column' gap='0.25rem'>
          <LoadingPlaceholder width={spacing.lg} height={spacing.lg} borderRadius={radius.full} />
        </Flex>
        <Flex flexDirection='column' gap={spacing.smx1}>
          <LoadingPlaceholder width={spacing.lgx2} height={spacing.md} borderRadius={radius.lg} />
          <LoadingPlaceholder width={spacing.huge} height={spacing.md} borderRadius={radius.lg} />
        </Flex>
      </Flex>
      <Flex flexDirection='row' justifyContent='flex-end' gap={spacing.smx2}>
        <LoadingPlaceholder width={spacing.lgx2} height={spacing.lg} borderRadius={radius.lg} />
      </Flex>
    </Flex>
  </CardWrapperStyled>
)

const CardWrapperStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: colors.white,
  borderRadius: radius.lgx1,
})
